import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function PricingTable() {
  const [selected, setSelected] = useState<'pro' | 'acelerador'>('acelerador');
  return <section id="pricing" className="py-16 px-4 pt-[25px] pb-[25px]" data-id="element-198">
      <div className="max-w-lg mx-auto" data-id="element-199">
        <div className="text-center mb-8" data-id="element-200">
          <h2 className="text-3xl md:text-4xl font-black mb-1" data-id="element-201">
            ELEGÍ TU{' '}
            <span className="text-brand" data-id="element-202">ULTRAPACK TERAPÉUTICO PRO™</span>
          </h2>
          <p className="text-gray-400 mt-2" data-id="element-203">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        <div className="flex flex-col gap-5" data-id="element-204">
          <motion.button type="button" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelected('pro')} className={`relative text-left bg-dark-card rounded-2xl p-5 flex items-start gap-4 transition-all cursor-pointer ${selected === 'pro' ? 'border-2 border-brand shadow-[0_0_30px_rgba(219,39,119,0.15)]' : 'border border-dark-border'}`} data-id="element-205">
            <div className="mt-1 flex-shrink-0" data-id="element-206">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'pro' ? 'border-brand' : 'border-gray-600'}`} data-id="element-207">
                {selected === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-brand" data-id="element-208" />}
              </div>
            </div>

            <div className="flex-1 min-w-0" data-id="element-209">
              <div className="flex items-start justify-between gap-3" data-id="element-210">
                <div data-id="element-211">
                  <div className="mb-1 text-[18px]" data-id="element-212">📘</div>
                  <h3 className="font-bold text-[14px]" data-id="element-213">
                    ULTRAPACK TERAPÉUTICO PRO™
                  </h3>
                  <p className="text-gray-400 mt-1 text-[12px]" data-id="element-214">
                    6 Tomos + 6 Bonos
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-215">
                  <div className="text-gray-500 line-through text-xs" data-id="element-216">
                    $34.990
                  </div>
                  <div className="text-2xl md:text-3xl font-black text-white leading-tight" data-id="element-217">
                    $19.990
                  </div>
                </div>
              </div>
            </div>
          </motion.button>

          <motion.button type="button" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} onClick={() => setSelected('acelerador')} className={`relative text-left bg-dark-card rounded-2xl p-5 pt-7 flex items-start gap-4 transition-all cursor-pointer ${selected === 'acelerador' ? 'border-2 border-brand shadow-[0_0_30px_rgba(219,39,119,0.15)]' : 'border border-dark-border'}`} data-id="element-218">
            {selected === 'acelerador' && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand text-white text-[10px] font-bold px-3 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-219">
                ⭐ MÁS ELEGIDO
              </span>}
            <div className="mt-1 flex-shrink-0" data-id="element-220">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'acelerador' ? 'border-brand' : 'border-gray-600'}`} data-id="element-221">
                {selected === 'acelerador' && <div className="w-2.5 h-2.5 rounded-full bg-brand" data-id="element-222" />}
              </div>
            </div>

            <div className="flex-1 min-w-0" data-id="element-223">
              <div className="flex items-start justify-between gap-3" data-id="element-224">
                <div data-id="element-225">
                  <div className="text-xl mb-1" data-id="element-226">🏆</div>
                  <h3 className="font-bold text-[14px]" data-id="element-227">
                    ULTRAPACK TERAPÉUTICO PRO™ + AT MASTER-DOC™
                  </h3>
                  <p className="text-gray-400 mt-1 text-[12px]" data-id="element-228">
                    6 Tomos + 6 Bonos + AT MASTER-DOC™ (Documentación blindada,
                    contratos élite, facturación y rentabilidad)
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-229">
                  <div className="text-gray-500 line-through text-xs" data-id="element-230">
                    $43.990
                  </div>
                  <div className="text-2xl md:text-3xl font-black text-brand leading-tight" data-id="element-231">
                    $27.990
                  </div>
                </div>
              </div>
              <p className="text-brand font-bold mt-3 text-[10px]" data-id="element-232">
                AHORRÁS $16.000. La más elegida por ATs que quieren
                profesionalizarse y cobrar lo que merecen.
              </p>
            </div>
          </motion.button>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-6" data-id="element-233">
          <a href={selected === 'acelerador' ? 'https://ultrapack.digital/cart/47862969008302:1' : 'https://ultrapack.digital/cart/47862967894190:1'} target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-brand hover:bg-brand-dark text-white font-bold py-4 px-6 rounded-xl transition-all hover:scale-[1.02] shadow-[0_0_30px_rgba(219,39,119,0.4)] text-[16px]" data-id="element-234">
            {selected === 'acelerador' ? '→ QUIERO EL ULTRAPACK + AT MASTER-DOC™' : '→ QUIERO MI ULTRAPACK AHORA'}
          </a>
        </motion.div>

        <div className="mt-8 flex flex-wrap justify-center gap-6 text-sm text-gray-500" data-id="element-235">
          <div className="flex items-center space-x-2" data-id="element-236">
            <span data-id="element-237">🔒</span> <span data-id="element-238">Pago seguro</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-239">
            <span data-id="element-240">⚡</span> <span data-id="element-241">Acceso en 5 min</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-242">
            <span data-id="element-243">🛡️</span> <span data-id="element-244">Garantía 7 días</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-245">
            <span data-id="element-246">💳</span> <span data-id="element-247">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}